import { CellTable } from "@/atoms"
import { InformationPopover } from "@/molecules/InformationPopover"

import type { SastGuidanceAPI } from "@/api/useSettings.types"

export const GuidanceNameCell = (name: string, record: SastGuidanceAPI) => {
  const { guidance } = record

  return (
    <InformationPopover.Popover
      open={guidance ? undefined : false}
      content={
        <InformationPopover.CommonTemplate title="Guidance Preview">
          {guidance}
        </InformationPopover.CommonTemplate>
      }
    >
      {CellTable(name, { noTooltip: true })}
    </InformationPopover.Popover>
  )
}
